module.exports = __webpack_public_path__ + "static/14-formation-deformation-s-ivx-65e9f1615f53617466d34485fff1e59a.jpg";